import { render, staticRenderFns } from "./HeaderVista.vue?vue&type=template&id=48082558&scoped=true"
import script from "./HeaderVista.vue?vue&type=script&lang=js"
export * from "./HeaderVista.vue?vue&type=script&lang=js"
import style0 from "./HeaderVista.vue?vue&type=style&index=0&id=48082558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48082558",
  null
  
)

export default component.exports